import { BookOpen, Target } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import { useI18n } from "../lib/i18n";

const ExerciseIntro = ({ exerciseInfo }) => {
  const { t } = useI18n();
  if (!exerciseInfo) return null;

  return (
    <Card data-testid="exercise-intro" className="border-l-4 border-l-primary bg-primary/[0.03]">
      <CardContent className="pt-6 space-y-4">
        <div className="flex items-start gap-3">
          <Target className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
          <div>
            <p className="font-semibold text-sm uppercase tracking-wide text-primary mb-2">
              {t("exerciseIntro.objectives")}
            </p>
            <ul className="space-y-1.5">
              {exerciseInfo.objectives.map((obj, i) => (
                <li key={i} className="text-sm text-muted-foreground flex items-start gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0" />
                  {obj}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t pt-4 flex items-start gap-3">
          <BookOpen className="w-5 h-5 text-primary/70 mt-0.5 flex-shrink-0" />
          <div>
            <p className="font-semibold text-sm uppercase tracking-wide text-primary/70 mb-2">
              {t("exerciseIntro.understand")}
            </p>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {exerciseInfo.explanation}
            </p>
            {exerciseInfo.foundation && (
              <p className="text-xs text-muted-foreground/70 mt-3 italic">
                {t("exerciseIntro.foundation")} {exerciseInfo.foundation}
              </p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ExerciseIntro;
